import { getLootdropData } from '@helpers/drops';
import { MessageEmitter } from '@phaser/events';
import { useTranslation } from 'react-i18next';
import { getItemColor } from '@helpers/items';
import { Modal } from '@components/ui/Modal';
import { useEffect, useState } from 'react';
import * as Shared from '@shared/lib';

interface LootItem {
  amount: number
  key: string;
  data: ReturnType<typeof getLootdropData>;
};

interface LootInfoProps {
  open: boolean;
  onClose: () => void;
};

export function LootInfo({ open, onClose }: LootInfoProps) {
  const [lootedItems, setLootedItems] = useState<LootItem[]>([]);

  const { t } = useTranslation(undefined, { keyPrefix: 'Game.LootInfo' });

  const onItemDrop = (message: Shared.LootDropMessage) => {
    const data = getLootdropData(message);
    if (!data) return;

    const ignoredItems = [Shared.ItemCode.ENERGY, Shared.ItemCode.HEALTH];
    if (ignoredItems.includes(data.id)) return;

    setLootedItems(li => {
      const exists = li.find(loof => loof.key === data.key);
      if (!exists) return [...li, { key: data.key, amount: message.amount, data }];

      for (const loof of li) {
        if (loof.key === data.key) loof.amount += message.amount;
      }

      return li;
    });
  };

  useEffect(() => {
    MessageEmitter.on('itemDrop', onItemDrop);
    return () => {
      MessageEmitter.off('itemDrop', onItemDrop);
    };
  }, []);

  return (
    <Modal onRequestClose={onClose} title={t('title')} isOpen={open}>
      {lootedItems.map(item => (
        <div className="text-sm flex items-center justify-between p-1 even:bg-white/10" key={item.key}>
          <p className={getItemColor(item.data!)}>{item.data!.name}</p>
          <p>{item.amount}</p>
        </div>
      ))}

      {lootedItems.length === 0 && (
        <p className="my-6 text-center text-gray-500 text-sm">
          {t('noItems')}
        </p>
      )}
    </Modal>
  );
}